/**
  *
  * CountdownBanner.js v1.0.0
  *
  * If your project is not on the Babel workflow, scroll down to the bottom
  * and use the ES5 version instead of the ES6+ version.
  *
  */

;((CountdownBanner, $) => {
  'use strict';

  let $dom = {};

  let datetime;
  let timeLeft;
  let interval;

  const carouselBannerSliderOptions = {
    slidesToShow: 1,
    arrows: true,
    dots: false,
    autoplay: true,
    infinite: true,
    prevArrow: $('.js-carousel-banner-slider-nav-prev'),
    nextArrow: $('.js-carousel-banner-slider-nav-next')
  };

  const cacheDom = () => {
    $dom.body = $('body');
    $dom.banner = $('.js-countdown-banner, .js-carousel-banner');
    $dom.active = $dom.banner.find('.js-countdown-active');
    $dom.timer = $dom.banner.find('.js-countdown-timer');
    $dom.numbers = $dom.timer.find('.js-countdown-number');
    $dom.days = $dom.timer.find('[data-countdown=days]').parent();
    $dom.seconds = $dom.timer.find('[data-countdown=seconds]').parent();
    $dom.colon = $dom.timer.find('.countdown-banner--timer-colon');
    $dom.carousel = $dom.banner.find('.js-carousel-banner-slider');
  };

  const setDatetimeObject = (dateString, timeString) => {
    const dateArray = dateString.split('/');
    const timeArray = timeString.split(':');
    const datetime = {
      month: (parseInt(dateArray[0]) - 1).toString(),
      day: dateArray[1],
      year: dateArray[2],
      hours: timeArray[0] || '00',
      minutes: timeArray[1] || '00',
      seconds: timeArray[2] || '00'
    };

    datetime.date = new Date(datetime.year,
      datetime.month,
      datetime.day,
      datetime.hours,
      datetime.minutes,
      datetime.seconds
    );
    return datetime;
  };

  const calculateTimeLeft = (datetime) => {
    const timeLeft = {};
    const now = new Date(Date.now());
    const diff = datetime.date - now;

    if (diff <= 0) {
      return false
    }

    timeLeft.seconds = (Math.floor((diff / 1000) % 60)).toString();
    timeLeft.minutes = (Math.floor((diff / 1000 / 60) % 60)).toString();
    timeLeft.days = (Math.floor((diff / (1000 * 60 * 60 * 24)))).toString();
    if (timeLeft.days>0) {
      timeLeft.hours = (Math.floor(((diff / (1000 * 60 * 60))-(timeLeft.days*24)))).toString();
    } else {
      timeLeft.hours = (Math.floor((diff / (1000 * 60 * 60)))).toString();
    }
    return timeLeft;
  };

  const timeStringify = (num) => {
    let numString = num.toString();
    if (numString.length === 1) {
      numString = `0${numString}`;
    }
    return numString;
  };

  const render = (timeLeft, callback) => {
    if (!timeLeft) {
      $dom.active.filter('[data-active-state="active"]').hide();
      $dom.active.filter('[data-active-state="inactive"]').show();
      $dom.active.filter('[data-active-state="inactive"]').addClass('banner-is-shown')
      $dom.active.filter('[data-active-state="active"]').removeClass('banner-is-shown')
      clearInterval(interval);
    } else {
      const days = timeStringify(timeLeft.days);
      const hours = timeStringify(timeLeft.hours);
      const minutes = timeStringify(timeLeft.minutes);
      const seconds = timeStringify(timeLeft.seconds);
      $dom.numbers.filter('[data-countdown="days"]').text(days);
      $dom.numbers.filter('[data-countdown="hours"]').text(hours);
      $dom.numbers.filter('[data-countdown="minutes"]').text(minutes);
      $dom.numbers.filter('[data-countdown="seconds"]').text(seconds);
      $dom.active.filter('[data-active-state="inactive"]').removeClass('banner-is-shown');
      $dom.active.filter('[data-active-state="active"]').addClass('banner-is-shown');
      if (days>0){
        $dom.days.css('display', 'block');
        $dom.colon.eq(0).css('display', 'block');
        $dom.seconds.css('display', 'none');
        $dom.colon.eq(2).css('display', 'none');
      } else {
        $dom.days.css('display', 'none');
        $dom.colon.eq(0).css('display', 'none');
        $dom.seconds.css('display', 'block');
        $dom.colon.eq(2).css('display', 'block');
      }
    }

    if (typeof callback === 'function') {
      callback(timeLeft);
    }
  };

  const cycle = () => {
    interval = setInterval(() => {
      render(calculateTimeLeft(datetime));
    }, 1000);
  };

  const getCountdownBannerHeight = function () {
    return $dom.banner.outerHeight();
  };

  const getBodyHeightFromTop = function () {
    return $dom.body.offset().top + parseInt($dom.body.css('padding-top').slice(0, -2), 10);
  };

  const setBodyPaddingTop = () => {
    $dom.body.add('.mobile-transformation-link-header').css('padding-top', getCountdownBannerHeight() + 'px');
    
  };

  const init = () => {
    cacheDom();
    if($dom.banner.hasClass('js-carousel-banner')) {
      setBodyPaddingTop();
      const slideCount = $dom.carousel.children().length;
      if(slideCount > 1) {
        $dom.carousel.slick(carouselBannerSliderOptions);
      }
    } else {
      if (CountdownBanner.dateString && CountdownBanner.timeString) {
        try {
          datetime = setDatetimeObject(CountdownBanner.dateString, CountdownBanner.timeString);
          const timeLeft = calculateTimeLeft(datetime);
          render(timeLeft, () => {
            $dom.banner.addClass('countdown-banner--visible');
            $dom.body.addClass('countdown-timer-is-active');
            // $dom.body.css('padding-top', getBodyHeightFromTop() + getCountdownBannerHeight() + 'px');
            setBodyPaddingTop();
          });
          cycle();
        } catch (error) {
          console.error(error);
        }
      }
    }
  };

  const bindUIActions = () => {
    $(window).on('scroll', () => {
      let updateBodyPaddingTop = false;
      if($(window).scrollTop() > 100) {
        if(!$('body').hasClass('scrolled-down')) {
          updateBodyPaddingTop = true;
        }
        $('body').addClass('scrolled-down');
      } else {
        if($('body').hasClass('scrolled-down')) {
          updateBodyPaddingTop = true;
        }
        $('body').removeClass('scrolled-down');
      }
      if(!!updateBodyPaddingTop) {
        setBodyPaddingTop();
      }
    });
    $(window).on('resize orientationchange', () => {
      init();
    });
  };

  CountdownBanner.init = () => {
    init();
    bindUIActions();
  };

})(window.CountdownBanner = window.CountdownBanner || {}, jQuery);


/**
  *
  * ES5 Fallback Version
  *
(function CountdownBanner(CountdownBanner, $) {
  'use strict';
  var $dom = {};
  var datetime;
  var timeLeft;
  var interval;
  var cacheDom = function cacheDom() {
    $dom.banner = $('.js-countdown-banner');
    $dom.active = $dom.banner.find('.js-countdown-active');
    $dom.timer = $dom.banner.find('.js-countdown-timer');
    $dom.numbers = $dom.timer.find('.js-countdown-number');
  };
  var setDatetimeObject = function setDatetimeObject(dateString, timeString) {
    var dateArray = dateString.split('/');
    var timeArray = timeString.split(':');
    var datetime = {
      month: (parseInt(dateArray[0]) - 1).toString(),
      day: dateArray[1],
      year: dateArray[2],
      hours: timeArray[0] || '00',
      minutes: timeArray[1] || '00',
      seconds: timeArray[2] || '00'
    };
    datetime.date = new Date(datetime.year,
      datetime.month,
      datetime.day,
      datetime.hours,
      datetime.minutes,
      datetime.seconds
    );
    return datetime;
  };
  var calculateTimeLeft = function calculateTimeLeft(datetime) {
    var timeLeft = {};
    var now = new Date(Date.now());
    var diff = datetime.date - now;
    if (diff <= 0) {
      return false
    }
    timeLeft.seconds = (Math.floor((diff / 1000) % 60)).toString();
    timeLeft.minutes = (Math.floor((diff / 1000 / 60) % 60)).toString();
    timeLeft.hours = (Math.floor((diff / (1000 * 60 * 60)))).toString();
    return timeLeft;
  };
  var timeStringify = function timeStringify(num) {
    var numString = num.toString();
    if (numString.length === 1) {
      numString = '0' + numString;
    }
    return numString;
  };
  var render = function render(timeLeft, callback) {
  if (!timeLeft) {
    $dom.active.filter('[data-active-state="active"]').hide();
    $dom.active.filter('[data-active-state="inactive"]').show();
    clearInterval(interval);
  } else {
    var hours = timeLeft.hours;
    var minutes = timeStringify(timeLeft.minutes);
    var seconds = timeStringify(timeLeft.seconds);
    $dom.numbers.filter('[data-countdown="hours"]').text(hours);
    $dom.numbers.filter('[data-countdown="minutes"]').text(minutes);
    $dom.numbers.filter('[data-countdown="seconds"]').text(seconds);
  }
    if (typeof callback === 'function') {
      callback(timeLeft);
    }
  };
  var cycle = function cycle() {
    interval = setInterval(function interval() {
      render(calculateTimeLeft(datetime));
    }, 1000);
  };
  var init = function init() {
    if (CountdownBanner.dateString && CountdownBanner.timeString) {
      try {
        cacheDom();
        datetime = setDatetimeObject(CountdownBanner.dateString, CountdownBanner.timeString);
        const timeLeft = calculateTimeLeft(datetime);
        render(timeLeft, function () {
          $dom.banner.addClass('countdown-banner--visible');
        });
        cycle();
      } catch (error) {
        console.error(error);
      }
    }
  };
  CountdownBanner.init = init;
})(window.CountdownBanner = window.CountdownBanner || {}, jQuery);
**/
